var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTyperightUp = function SvgTyperightUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.425 4h-.75v1.5h10.763L4.468 18.47l-.53.53 1.06 1.06.531-.53L18.5 6.56v10.765H20V4H7.426Z"
  })));
};
export { SvgTyperightUp as ReactComponent };
export default __webpack_public_path__ + "4bbea344ecf56d1b87962050dcfa7dff.svg";